// extracted by mini-css-extract-plugin
export var icon = "CustomSearch-module--icon--fa3e6";
export var root = "CustomSearch-module--root--8c434";